module.exports = __webpack_public_path__ + "img/dice-gray.6be82310.svg";